import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import Nav from './components/Nav';
import LoginForm from './components/LoginForm';
import Clock from './components/clock';
import './App.css';
import Loading from "./components/loader";
import { enqueueSnackbar } from "notistack";
import LoadingModule from "./components/LoadingModule";

// Компоненты страниц
import Info from './components/info';
import VoteStream from './components/voteStream';
import VoteActive from './components/voteActive';
import VoteOneResult from './components/voteOneResult';
import VoteExtended from './components/voteExtended';
import VoteDocs from './components/voteDocs';
import VoteResults from './components/voteResults';
import VoteSave from './components/voteSave';
import VoteRegUsers from './components/voteRegUsers';
import VoteUsers from './components/voteUsers';
import VoteAllUsers from './components/voteAllUsers';
import VoteMeetings from './components/voteMeetings';
import VoteUserMeetings from './components/voteUserMeetings';
import VoteMeetingRedact from './components/voteMeetingRedact';
import VoteMeetingCreate from './components/voteMeetingCreate';
import VoteMeetingRedactDocs from './components/voteMeetingRedactDocs';
import VoteAgendaPreShow from './components/voteAgendaPreShow';
import VoteAgendaCreate from './components/voteAgendaCreate';
import VoteAgendaRedact from './components/voteAgendaRedact';
import User_Profile from './components/user_profile';
import InlineError from './components/InlineError';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayed_form: '',
      logged_in: localStorage.getItem('token') ? true : false,
      esia_in: localStorage.getItem('esia_login'),
      username: '',
      personname: '',
      wrong_input: true,
      email: '',
      is_staff: '',
      is_superuser: '',
      full_name: '',
      isLoading: true,
      isFetchingAfterLogin: false,
      isAutoLogin: false,
    };
    this.child = React.createRef();
  }

  async componentDidMount() {
    const { REACT_APP_SELF_ADDRESS, REACT_APP_API_ADDRESS, REACT_APP_ESIA_REDIRECT_LOGOUT_URL, REACT_APP_MAINTENANCE_MODE } = process.env;
    const hash = window.location.hash;

    if (hash) {
        const hashParamsString = hash.replace('#/', '').replace('#', '');
        const hashParams = new URLSearchParams(hashParamsString);
        const key = hashParams.get('key');

        if (key) {
            try {
                const response = await fetch(`${REACT_APP_API_ADDRESS}check_key/?key=${key}`);
                const data = await response.json();

                if (data.status === 'OK') {
                    await this.handleAutoLogin(data.user_data);
                } else {
                    enqueueSnackbar('Недействительная ссылка для входа', {variant: 'error'});
                }
            } catch (error) {
                enqueueSnackbar('Произошла ошибка при проверке ссылки', {variant: 'error'});
            }
        }
    }

    if (this.state.logged_in) {
        this.setupTokenRefresh();

        // Проверяем роль пользователя при загрузке приложения
        const maintenanceMode = REACT_APP_MAINTENANCE_MODE === 'true';

        if (maintenanceMode) {
            try {
                const token = localStorage.getItem('token');
                const res = await fetch(`${REACT_APP_API_ADDRESS}current_user/`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                const json = await res.json();

                if (json.data) {
                    const isStaff = json.data.is_staff;
                    const isSuperuser = json.data.is_superuser;

                    // Если не админ → разлогиниваем
                    if (!isStaff && !isSuperuser) {
                        enqueueSnackbar('У вас нет доступа', { variant: 'error' });
                        this.handle_logout();
                        return;
                    }

                    // Сохраняем данные пользователя
                    this.setState({
                        username: json.data.username,
                        is_staff: isStaff,
                        is_superuser: isSuperuser,
                        email: json.data.email,
                        personname: json.full_name,
                    });
                }
            } catch (error) {
                console.error("Ошибка при проверке роли:", error);
                this.handle_logout();
            }
        } else {
            // Обычный режим — просто загружаем данные пользователя
            await this.fetchCurrentUser();
        }
    } else {
        this.handle_logout();
    }

    this.setState({isLoading: false});
}

  componentWillUnmount() {
    this.stopTokenRefresh();
  }

  setupTokenRefresh = () => {
    this.stopTokenRefresh(); // на случай повторного вызова

    this.timerID = setInterval(async () => {
      const refresh_token = localStorage.getItem('refresh_token');
      if (!refresh_token) {
        this.handle_logout();
        return;
      }

      const { REACT_APP_API_ADDRESS } = process.env;
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ refresh: refresh_token })
      };

      try {
        const res = await fetch(`${REACT_APP_API_ADDRESS}refresh-token/`, requestOptions);
        const json = await res.json();

        if (res.ok && json.access) {
          localStorage.setItem('token', json.access);
        } else {
          console.warn('Ошибка:', json);
          this.handle_logout();
        }
      } catch (err) {
        console.error('Ошибка:', err);
        this.handle_logout();
      }
    }, 14 * 60 * 1000);
  };

  stopTokenRefresh = () => {
    if (this.timerID) {
      clearInterval(this.timerID);
      this.timerID = null;
    }
  };

  handle_login = async (e, data) => {
    const { REACT_APP_API_ADDRESS, REACT_APP_MAINTENANCE_MODE } = process.env;
    this.setupTokenRefresh();
    e.preventDefault();

    try {
        const response = await fetch(`${REACT_APP_API_ADDRESS}token-auth/`, {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({ username: data.username, password: data.password }),
        });

        const json = await response.json();

        if (json.access && json.refresh) {
            // Сохраняем оба токена
            localStorage.setItem("token", json.access);
            localStorage.setItem("refresh_token", json.refresh);

            const maintenanceMode = REACT_APP_MAINTENANCE_MODE === 'true';

            if (maintenanceMode) {
                // В режиме обслуживания проверяем роль
                try {
                    const res = await fetch(`${REACT_APP_API_ADDRESS}current_user/`, {
                        headers: {
                            Authorization: `Bearer ${json.access}`,
                        },
                    });
                    const userJson = await res.json();

                    if (userJson.data) {
                        const isStaff = userJson.data.is_staff;
                        const isSuperuser = userJson.data.is_superuser;

                        // Если не сотрудник и не админ → разлогиниваем
                        if (!isStaff && !isSuperuser) {
                            enqueueSnackbar('У вас нет доступа', { variant: 'error' });
                            this.handle_logout();
                            return;
                        }

                        // Сохраняем данные пользователя
                        this.setState({
                            logged_in: true,
                            displayed_form: "",
                            username: userJson.data.username,
                            email: userJson.data.email,
                            wrong_input: false,
                            is_staff: isStaff,
                            is_superuser: isSuperuser,
                            personname: userJson.full_name,
                            isFetchingAfterLogin: !data.isAdmin,
                        });

                        // Вызываем остальные методы
                        if (this.state.email) {
                            try {
                                await fetch(
                                    `${REACT_APP_API_ADDRESS}login_user/?email=${this.state.email}&username=${this.state.username}`,
                                    {
                                        method: "GET",
                                        headers: {
                                            Authorization: `Bearer ${json.access}`,
                                            "Content-Type": "application/json",
                                        },
                                    }
                                );
                            } catch (err) {
                                console.error("Ошибка при логине", err);
                            }
                        }

                        if (userJson.data.id && json.access) {
                            try {
                                await fetch(`${REACT_APP_API_ADDRESS}update_connections_login/${userJson.data.id}/`, {
                                    method: "POST",
                                    headers: {
                                        Authorization: `Bearer ${json.access}`,
                                        "Content-Type": "application/json",
                                    },
                                });
                            } catch (err) {
                                console.error("Ошибка при обновлении:", err);
                            }
                        }

                        this.setState({ isFetchingAfterLogin: false });
                    }
                } catch (error) {
                    console.error("Ошибка при проверке роли:", error);
                    this.handle_logout();
                    document.querySelector(".warn_alert_bttn")?.click();
                }
            } else {
                // Обычный режим — без проверки роли
                this.setState({
                    logged_in: true,
                    displayed_form: "",
                    username: json.user?.username || "",
                    email: json.user?.email || "",
                    wrong_input: false,
                    isFetchingAfterLogin: !data.isAdmin,
                });

                await this.fetchCurrentUser();

                const user_id = json.user?.id;
                const token = json.access;

                if (this.state.email) {
                    try {
                        await fetch(
                            `${REACT_APP_API_ADDRESS}login_user/?email=${this.state.email}&username=${this.state.username}`,
                            {
                                method: "GET",
                                headers: {
                                    Authorization: `Bearer ${token}`,
                                    "Content-Type": "application/json",
                                },
                            }
                        );
                    } catch (err) {
                        console.error("Ошибка при вызове login_user:", err);
                    }
                }

                if (user_id && token) {
                    try {
                        await fetch(`${REACT_APP_API_ADDRESS}update_connections_login/${user_id}/`, {
                            method: "POST",
                            headers: {
                                Authorization: `Bearer ${token}`,
                                "Content-Type": "application/json",
                            },
                        });
                    } catch (err) {
                        console.error("Ошибка при обновлении соединений:", err);
                    }
                }

                this.setState({ isFetchingAfterLogin: false });
            }
        } else {
            this.handle_logout();
            this.setState({
                logged_in: false,
                displayed_form: "login",
                wrong_input: true,
                isFetchingAfterLogin: false,
            });
            document.querySelector(".warn_alert_bttn")?.click();
        }
    } catch (error) {
        this.handle_logout();
        this.setState({
            logged_in: false,
            displayed_form: "login",
            wrong_input: true,
            isFetchingAfterLogin: false,
        });
        document.querySelector(".warn_alert_bttn")?.click();
    }
};

  fetchCurrentUser = async () => {
    const REACT_APP_API_ADDRESS = process.env.REACT_APP_API_ADDRESS;
    const token = localStorage.getItem("token");

    try {
      const res = await fetch(`${REACT_APP_API_ADDRESS}current_user/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const json = await res.json();

      if (json.data !== undefined) {
        const hasLink = json.has_link;
        const openModalOnRedirect = localStorage.getItem("openModalOnRedirect");

        if (hasLink && (!openModalOnRedirect || openModalOnRedirect === "false")) {
          enqueueSnackbar('Необходимо установить пароль', { variant: 'error' });
          this.handle_logout();
          return;
        }

        const userData = json.data;

        this.setState({
          username: userData.username,
          is_staff: userData.is_staff,
          is_superuser: userData.is_superuser,
          email: userData.email,
          personname: json.full_name,
        });
      } else {
        throw new Error("Пользовательские данные не получены");
      }
    } catch (error) {
      console.error("Ошибка при получении текущего пользователя:", error);
      this.handle_logout();
    }
  };

  handleAutoLogin = async (userData) => {
    const { REACT_APP_API_ADDRESS, REACT_APP_MAINTENANCE_MODE } = process.env;
    const { username, password } = userData;
    const maintenanceMode = REACT_APP_MAINTENANCE_MODE === 'true';

    try {
        const response = await fetch(`${REACT_APP_API_ADDRESS}token-auth/`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ username, password }),
        });

        const json = await response.json();

        if (json.access && json.refresh) {
            // Сохраняем оба токена
            localStorage.setItem("token", json.access);
            localStorage.setItem("refresh_token", json.refresh);

            if (maintenanceMode) {
                // Проверяем роль пользователя в режиме обслуживания
                try {
                    const res = await fetch(`${REACT_APP_API_ADDRESS}current_user/`, {
                        headers: {
                            Authorization: `Bearer ${json.access}`,
                        },
                    });
                    const userJson = await res.json();

                    if (userJson.data) {
                        const isStaff = userJson.data.is_staff;
                        const isSuperuser = userJson.data.is_superuser;

                        // Если пользователь не админ → разлогиниваем
                        if (!isStaff && !isSuperuser) {
                            enqueueSnackbar('У вас нет доступа к системе в режиме технического обслуживания', {
                                variant: 'error',
                                persist: true
                            });
                            this.handle_logout();
                            return;
                        }

                        // Сохраняем данные пользователя
                        this.setState({
                            logged_in: true,
                            username: userJson.data.username,
                            email: userJson.data.email,
                            wrong_input: false,
                            is_staff: isStaff,
                            is_superuser: isSuperuser,
                            personname: userJson.full_name,
                            isFetchingAfterLogin: true,
                            isAutoLogin: true,
                        });

                        localStorage.setItem("openModalOnRedirect", "true");
                        this.setupTokenRefresh();

                        // Вызываем остальные методы
                        if (userJson.data.email) {
                            try {
                                await fetch(
                                    `${REACT_APP_API_ADDRESS}login_user/?email=${userJson.data.email}&username=${userJson.data.username}`,
                                    {
                                        method: "GET",
                                        headers: {
                                            Authorization: `Bearer ${json.access}`,
                                            "Content-Type": "application/json",
                                        },
                                    }
                                );
                            } catch (err) {
                                console.error("Ошибка при логине", err);
                            }
                        }

                        if (userJson.data.id && json.access) {
                            try {
                                await fetch(`${REACT_APP_API_ADDRESS}update_connections_login/${userJson.data.id}/`, {
                                    method: "POST",
                                    headers: {
                                        Authorization: `Bearer ${json.access}`,
                                        "Content-Type": "application/json",
                                    },
                                });
                            } catch (err) {
                                console.error("Ошибка при обновлении:", err);
                            }
                        }

                        this.setState({ isFetchingAfterLogin: false });
                        window.location.href = `/#/settings/`;
                        this.setState({ isAutoLogin: false });
                    }
                } catch (error) {
                    console.error("Ошибка при проверке роли:", error);
                    this.handle_logout();
                }
            } else {
                // Обычный режим — без проверки роли
                this.setState({
                    logged_in: true,
                    username: username,
                    email: json.user?.email || "",
                    wrong_input: false,
                    isFetchingAfterLogin: true,
                    isAutoLogin: true,
                });

                localStorage.setItem("openModalOnRedirect", "true");
                this.setupTokenRefresh();

                await this.fetchCurrentUser();

                const user_id = json.user?.id;
                const token = json.access;

                if (this.state.email) {
                    try {
                        await fetch(
                            `${REACT_APP_API_ADDRESS}login_user/?email=${this.state.email}&username=${this.state.username}`,
                            {
                                method: "GET",
                                headers: {
                                    Authorization: `Bearer ${token}`,
                                    "Content-Type": "application/json",
                                },
                            }
                        );
                    } catch (err) {
                        console.error("Ошибка при вызове login_user:", err);
                    }
                }

                if (user_id && token) {
                    try {
                        await fetch(`${REACT_APP_API_ADDRESS}update_connections_login/${user_id}/`, {
                            method: "POST",
                            headers: {
                                Authorization: `Bearer ${token}`,
                                "Content-Type": "application/json",
                            },
                        });
                    } catch (err) {
                        console.error("Ошибка при обновлении соединений:", err);
                    }
                }

                this.setState({ isFetchingAfterLogin: false });
                window.location.href = `/#/settings/`;
                this.setState({ isAutoLogin: false });
            }
        }
    } catch (error) {
        console.error("Auto-login failed:", error);
        this.setState({ isFetchingAfterLogin: false });
        this.handle_logout();
    }
};

  handle_logout = () => {
    const {REACT_APP_SELF_ADDRESS, REACT_APP_API_ADDRESS, REACT_APP_ESIA_REDIRECT_LOGOUT_URL} = process.env;
    localStorage.removeItem('token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('esia_login');
    this.setState({logged_in: false, username: ''});
    this.setState({displayed_form: 'login'});
    this.stopTokenRefresh();
    this.props.history.push('/');
    if (this.state.esia_in === 'true') {
      this.setState({esia_in: false})
      localStorage.setItem('esia_login', false);
      window.location.href = `${REACT_APP_ESIA_REDIRECT_LOGOUT_URL}`;
    }
  };

  display_form = form => {
    this.setState({displayed_form: form});
  };

  getNavProps = () => {
    return {
      logged_in: this.state.logged_in,
      username: this.state.username,
      personname: this.state.personname,
      handle_logout: this.handle_logout,
      is_staff: this.state.is_staff,
      is_superuser: this.state.is_superuser,
      isFetchingAfterLogin: this.state.isFetchingAfterLogin,
    };
  };

  render() {
    if (this.state.isLoading) {
      if (this.state.isAutoLogin) {
        return (
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '80vh',
            width: '100%'
          }}>
            <LoadingModule />
          </div>
        );
      } else {
        return <div><Loading /></div>;
      }
    }

    if (!this.state.logged_in) {
      return (
        <LoginForm
          handle_login={this.handle_login}
          wrong_input={this.state.wrong_input}
        />
      );
    }

    return (
      <>
        <Clock
          ref={this.child}
          logged_in={this.state.logged_in}
          logout={this.handle_logout}
        />
        <div className="App">
          <Switch>
            {/* Главная страница */}
            <Route
              exact path="/"
              render={(routeProps) => (
                <Nav {...this.getNavProps()}>
                  <Info
                    {...this.getNavProps()}
                    {...routeProps}
                    is_staff={this.state.is_staff}
                    is_superuser={this.state.is_superuser}
                  />
                </Nav>
              )}
            />

            {/* Страницы с параметрами */}
            <Route
              path="/voteExtended/:meetingId/:selectedAccountId/:selectedUniquifier"
              render={(routeProps) => (
                <Nav {...this.getNavProps()}>
                  <VoteExtended {...this.getNavProps()} {...routeProps} />
                </Nav>
              )}
            />

            <Route
              path="/voteStream/:meetingId"
              render={(routeProps) => (
                <Nav {...this.getNavProps()}>
                  <VoteStream {...this.getNavProps()} {...routeProps} />
                </Nav>
              )}
            />

            <Route
              path="/voteActive/:meetingId/:selectedAccountId/:selectedUniquifier"
              render={(routeProps) => (
                <Nav {...this.getNavProps()}>
                  <VoteActive {...this.getNavProps()} {...routeProps} />
                </Nav>
              )}
            />

            <Route
              path="/voteOneResult/:meetingId/:selectedAccountId/:selectedUniquifier/:voteCountId?"
              render={(routeProps) => (
                <Nav {...this.getNavProps()}>
                  <VoteOneResult {...this.getNavProps()} {...routeProps} />
                </Nav>
              )}
            />

            <Route
              path="/voteDocs/:meetingId"
              render={(routeProps) => (
                <Nav {...this.getNavProps()}>
                  <VoteDocs {...this.getNavProps()} {...routeProps} />
                </Nav>
              )}
            />

            <Route
              path="/voteResults/:meetingId"
              render={(routeProps) => (
                <Nav {...this.getNavProps()}>
                  <VoteResults {...this.getNavProps()} {...routeProps} />
                </Nav>
              )}
            />

            <Route
              path="/voteUsers/:meetingId"
              render={(routeProps) => (
                <Nav {...this.getNavProps()}>
                  <VoteUsers
                    {...this.getNavProps()}
                    {...routeProps}
                    is_staff={this.state.is_staff}
                    is_superuser={this.state.is_superuser}
                  />
                </Nav>
              )}
            />

            <Route
              path="/voteAllUsers"
              render={(routeProps) => (
                <Nav {...this.getNavProps()}>
                  <VoteAllUsers
                    {...this.getNavProps()}
                    {...routeProps}
                    is_staff={this.state.is_staff}
                    is_superuser={this.state.is_superuser}
                  />
                </Nav>
              )}
            />

            <Route
              path="/voteUserMeetings/:userId"
              render={(routeProps) => (
                <Nav {...this.getNavProps()}>
                  <VoteUserMeetings
                    {...this.getNavProps()}
                    {...routeProps}
                    is_staff={this.state.is_staff}
                    is_superuser={this.state.is_superuser}
                  />
                </Nav>
              )}
            />

            <Route
              path="/voteMeetings"
              render={(routeProps) => (
                <Nav {...this.getNavProps()}>
                  <VoteMeetings
                    {...this.getNavProps()}
                    {...routeProps}
                    is_staff={this.state.is_staff}
                    is_superuser={this.state.is_superuser}
                  />
                </Nav>
              )}
            />

            <Route
              path="/voteMeetingCreate"
              render={(routeProps) => (
                <Nav {...this.getNavProps()}>
                  <VoteMeetingCreate
                    {...this.getNavProps()}
                    {...routeProps}
                    is_staff={this.state.is_staff}
                    is_superuser={this.state.is_superuser}
                  />
                </Nav>
              )}
            />

            <Route
              path="/voteMeetingRedactDocs/:meetingId"
              render={(routeProps) => (
                <Nav {...this.getNavProps()}>
                  <VoteMeetingRedactDocs
                    {...this.getNavProps()}
                    {...routeProps}
                    is_staff={this.state.is_staff}
                    is_superuser={this.state.is_superuser}
                  />
                </Nav>
              )}
            />

            <Route
              path="/voteAgendaPreShow/:meetingId"
              render={(routeProps) => (
                <Nav {...this.getNavProps()}>
                  <VoteAgendaPreShow
                    {...this.getNavProps()}
                    {...routeProps}
                    is_staff={this.state.is_staff}
                    is_superuser={this.state.is_superuser}
                  />
                </Nav>
              )}
            />

            <Route
              path="/VoteAgendaCreate/:meetingId"
              render={(routeProps) => (
                <Nav {...this.getNavProps()}>
                  <VoteAgendaCreate
                    {...this.getNavProps()}
                    {...routeProps}
                    is_staff={this.state.is_staff}
                    is_superuser={this.state.is_superuser}
                  />
                </Nav>
              )}
            />

            <Route
              path="/voteSave"
              render={(routeProps) => (
                <Nav {...this.getNavProps()}>
                  <VoteSave {...this.getNavProps()} {...routeProps} />
                </Nav>
              )}
            />

            <Route
              path="/VoteRegUsers/:meetingId"
              render={(routeProps) => (
                <Nav {...this.getNavProps()}>
                  <VoteRegUsers
                    {...this.getNavProps()}
                    {...routeProps}
                    is_staff={this.state.is_staff}
                    is_superuser={this.state.is_superuser}
                  />
                </Nav>
              )}
            />

            <Route
              path="/VoteMeetingRedact/:meetingId"
              render={(routeProps) => (
                <Nav {...this.getNavProps()}>
                  <VoteMeetingRedact
                    {...this.getNavProps()}
                    {...routeProps}
                  />
                </Nav>
              )}
            />

            <Route
              path="/VoteAgendaRedact/:meetingId"
              render={(routeProps) => (
                <Nav {...this.getNavProps()}>
                  <VoteAgendaRedact
                    {...this.getNavProps()}
                    {...routeProps}
                    is_staff={this.state.is_staff}
                    is_superuser={this.state.is_superuser}
                  />
                </Nav>
              )}
            />

            <Route
              path="/settings"
              render={(routeProps) => (
                <Nav {...this.getNavProps()}>
                  <User_Profile {...this.getNavProps()} {...routeProps} />
                </Nav>
              )}
            />

            <Route>
              <InlineError errorType={404} />
            </Route>
          </Switch>
        </div>
      </>
    );
  }
}

export default withRouter(App);